/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { fetchLastLogins } from '../core/_requests'
import moment from 'moment'

const LastLoginUsers = () => {
  const token = localStorage.getItem('@auth/token')
  const [lastLogins, setLastLogins] = useState<any[]>([])

  const fetchLastLoginUsers = async () => {
    try {
      const response = await fetchLastLogins(token ?? '')
      if (response && response['hydra:member']) {
        setLastLogins(response['hydra:member'])
      }
    } catch (error) {
      console.error('Error fetching last logins:', error)
    }
  }

  useEffect(() => {
    fetchLastLoginUsers()
  }, [])

  const getMembershipStatusClass = (user: any) => {
    if (user.membershipActive) {
      return 'badge-light-success'
    } else if (user.membershipExpired) {
      return 'badge-light-danger'
    } else {
      return 'badge-light-warning'
    }
  }

  const getMembershipStatusText = (user: any) => {
    if (user.membershipActive) {
      return 'Active'
    } else if (user.membershipExpired) {
      return 'Expired'
    } else {
      return 'Inactive'
    }
  }

  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A'
    return moment.utc(dateString).format('DD/MM/YYYY HH:mm')
  }

  return (
    <div className='col-xl-4'>
      <div className='card card-xl-stretch mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold text-dark'>Last User Logins</span>
            <span className='text-muted mt-2 fw-semibold fs-7'>Recent user activity</span>
          </h3>
        </div>

        <div className='card-body py-3'>
          {lastLogins.length > 0 ? (
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-150px'>User</th>

                    <th className='min-w-100px'>Membership</th>
                    <th className='min-w-100px'>Last Login</th>
                  </tr>
                </thead>
                <tbody>
                  {lastLogins.map((user, index) => (
                    <tr key={index}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex justify-content-start flex-column'>
                            <span className='text-dark fw-bold fs-6'>{user.fullname}</span>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span className={`badge ${getMembershipStatusClass(user)}`}>
                          {getMembershipStatusText(user)}
                        </span>
                        {user.membershipPackage && (
                          <span className='text-muted fw-semibold d-block fs-7 mt-1'>
                            {user.membershipPackage.name}
                          </span>
                        )}
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {formatDate(user.last_access)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <span className='text-muted'>No login data available</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LastLoginUsers
